import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Row,
  Col,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
} from "availity-reactstrap-validation";
import Select from "react-select";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import moment from "moment";
import Swal from "sweetalert2";

import "./NewRequestForQuotation.scss";
import {
  getUserLocations,
  getMiniTaxs,
  getMiniVendors,
  // getDepartment,
  // getUserDepartment,
} from "../../../store/Mini/actions";
import {
  getServiceIndentList,
  InputChangeValue,
  rfqNoSelecteChangeValue,
  rfqLocationSelecteChangeValue,
  SelecteChangeValue,
  getServiceRequestRequestdata,
  itemQtyChangeValue,
  itemUnitSelecteChangeValue,
  itemPriceChangeValue,
  itemDiscountPercentChangeValue,
  itemBasePriceChangeValue,
  itemTaxSelecteChangeValue,
  itemTaxTypeSelecteChangeValue,
  itemGrossValChangeValue,
  quotationAdd,
  getQuotationData,
  QItemRemove,
  // getMRItemImges,
  RFQMRItemImagesModel_close,
} from "../../../store/SRPurchaseOrder/actions";
import LoadingModel from "../../LoadingModel";
import ItemDetails from "../../ItemDetails";
import MRItemImages from "../../MRItemImages";

const taxTypeOptions = [
  { value: 1, label: "Inclusive" },
  { value: 2, label: "Exclusive" },
];
class NewQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item_details: {},
    };

    this.loadRFQdata = this.loadRFQdata.bind(this);
    this.itemChangeHandeler = this.itemChangeHandeler.bind(this);
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.caluclategross = this.caluclategross.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  caluclategross(e, item, type) {
    var qty;
    var price;
    var baseprice;
    var taxtype;
    var tax;
    var discountpercent;
    var discount;
    switch (type) {
      case 1:
        qty = e.target.value ? e.target.value : 0;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        this.props.itemQtyChangeValue({
          key: e.target.name,
          value: e.target.value ? e.target.value : 0,
          item,
        });
        break;
      case 2:
        qty = item.qty;
        price = item.price;
        discountpercent = parseFloat(
          e.target.value ? e.target.value : 0
        ).toFixed(2);
        baseprice = parseFloat(item.baseprice ? item.baseprice : 0).toFixed(2);
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = parseFloat(
          baseprice - baseprice * (discountpercent / 100)
        ).toFixed(2);
        discount = parseFloat(baseprice - price).toFixed(2);

        this.props.itemDiscountPercentChangeValue({
          key: e.target.name,
          value: parseFloat(e.target.value ? e.target.value : 0),
          price,
          discount,
          item,
        });

        break;
      case 3:
        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = parseFloat(e.value ? e.value : 0);
        tax = item.tax?.tax;
        this.props.itemTaxTypeSelecteChangeValue({
          key: "taxtype_name",
          label: e.label,
          key2: "taxtype_id",
          value: parseFloat(e.value ? e.value : 0),
          item,
        });
        break;
      case 4:
        var taxData = this.props.Taxlist.filter((i) => {
          return i.id === e.value;
        });

        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = taxData[0].tax;
        this.props.itemTaxSelecteChangeValue({
          id: taxData[0].id,
          name: taxData[0].name,
          tax: taxData[0].tax,
          item,
        });
        break;
      case 5:
        qty = item.qty;
        price = item.price;
        baseprice = parseFloat(e.target.value ? e.target.value : 0);
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = baseprice - baseprice * (discountpercent / 100);
        discount = parseFloat(baseprice - price).toFixed(2);

        this.props.itemBasePriceChangeValue({
          key: e.target.name,
          value: baseprice,
          price,
          discount,
          // discountpercent,
          item,
        });
        break;
      default:
        break;
    }

    var gross = price * parseFloat(qty).toFixed(3);
    var taxamt = 0;
    if (taxtype === 1) {
      var basicValue = gross / ((100 + tax) / 100);
      taxamt = (basicValue / 100) * tax;
      var net = parseFloat(taxamt + basicValue).toFixed(3);
    } else {
      taxamt = (gross * tax) / 100;
      net = parseFloat(parseFloat(gross) + parseFloat(taxamt)).toFixed(3);
    }

    this.props.itemGrossValChangeValue(
      parseFloat(taxamt).toFixed(3),
      net,
      item
    );
  }
  componentDidMount() {
    this.props.getServiceIndentList();
    this.props.getUserLocations();
    this.props.getMiniTaxs();
    // this.props.getMiniVendors({
    // 	...this.props.vendorParams,
    // 	page: 1,
    // 	page_size: 10,
    // 	search: "",
    // });
    var id = 0;
    // if (this.props.byVendor) {
    //   id = parseInt(this.props.openId);
    //   this.props.getServiceRequestRequestdata(
    //     this.props.VendorData.requestforquotation,
    //     this.props.byVendor
    //   );
    // } else {
    //   id = parseInt(this.props.match.params.id);
    // }
    if (id !== 0) {
      this.setState((prevState) => ({
        id: id,
        defaultColDef: {
          ...prevState.defaultColDef,
          editable: false,
        },
      }));

      // this.props.getProductRowData(id, this.props.history);
      this.props.getQuotationData(id);
    } else {
      this.setState({
        id: 0,
      });
    }

    // if (this.state.id !== "0") {
    //   this.props.getQuotationData(this.state.id);
    // }
  }
  loadRFQdata() {
    this.props.getServiceRequestRequestdata(
      this.props.QRfQNo.requestforquotation_id,
      false
    );
  }
  itemChangeHandeler(e, item) {
    this.props.itemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
    });
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }

  componentDidUpdate(prevProps) {
    console.log("service indent  Row Data:", this.props.serviceIndent);
    console.log("vendors list data:", this.props.vendorslist);
    console.log("vendor info:", this.props.vendor);
  }
  RemoveQItem(item) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.QItemRemove(item);
      }
    });
  }
  handleValidSubmit() {
    if (this.props.qitems.length !== 0) {
      var quotationItems = [];
      this.props.qitems.map((p) => {
        var qitem = {
          //srfqitem_id:p?.id,
          siitem_id: p?.id,
          product_id: p.product?.id,
          qty: parseFloat(p.qty ? p.qty : 0).toFixed(3),
          unit_id: p.unit?.id,
          tax_id: p.tax?.id,
          taxtype: p.taxtype?.id,
          taxamount: parseFloat(p.taxamt ? p.taxamt : 0).toFixed(2),
          // srfqitem_id: p.srfqitem,
          price: parseFloat(p.price ? p.price : 0).toFixed(2),
          baseprice: parseFloat(p.baseprice ? p.baseprice : 0).toFixed(2),
          discount: parseFloat(p.discount ? p.discount : 0).toFixed(2),
          discountpercent: parseFloat(
            p.discountpercent ? p.discountpercent : 0
          ).toFixed(2),
          gross: parseFloat(p.gross ? p.gross : 0).toFixed(2),
          make: p.make,
          description: p.description,
          dodelete: p.dodelete,
        };
        if (this.state.id !== 0 && !this.props.byVendor) {
          qitem["id"] = p.id;
        }
        quotationItems.push(qitem);

        return 0;
      });
      var sum = 0;
      var totalsum = 0;
      this.props.qitems.every((item, i) => {
        if (item.price) {
          if (item.taxtype != null && item.taxtype !== "") {
            if (item.tax?.id != null && item.tax?.id !== "") {
              sum = sum + parseFloat(item.gross);
              if (i + 1 === this.props.qitems.length) {
                totalsum = sum;
              }
              return true;
            } else {
              Swal.fire({
                icon: "error",
                title: "Select Tax",
              });
              return false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Select Tax Type",
            });

            return false;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Enter Price",
          });
          return false;
        }
      });
      console.log("sqitems", quotationItems);
      var data = {
        servicerequestforquotation_id: this.props?.RFQrowdata?.id,
        token: this.props.token == null ? "" : this.props.token,
        deliverydate: this.props.QRowData.deliverydate,
        location_id: this.props.location.location_id,
        pnf: this.props.QRowData.pnf,
        // servicerequestforquotation_id:
        //   this.props.QRowData?.servicerequestforquotation,
        description: this.props.QRowData.description,
        terms: this.props.QRowData.terms,
        delivery: this.props.QRowData.delivery,
        payment: this.props.QRowData.payment,
        transport: this.props.QRowData.transport,
        gstdetails: this.props.QRowData.gstdetails,
        remarks: this.props.QRowData.remarks,
        externalremarks: this.props.QRowData.externalremarks,
        total: parseFloat(totalsum ? totalsum : 0).toFixed(2),
        vendor_id: this.props.byVendor
          ? this.props.VendorData.vendor
          : this.props.QRowData.vendor_id,
        woitems: quotationItems,
      };
      console.log("DATA", this.props?.qitems[0]?.id);
      if (data.vendor_id != null) {
        if (data.deliverydate != null) {
          if (data.terms != null) {
            if (data.description != null) {
              if (!isNaN(data.total) || data.total) {
                Swal.fire({
                  title: "Are you sure?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Submit",
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.props.quotationAdd(
                      data,
                      this.state.id,
                      this.props.history
                    );
                    console.log("Print Log Data :::::::", data);
                  }
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Check Item Details",
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Enter Other Details",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Enter Terms & Conditions",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Select Delivery Date",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Select Vendor",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Items are not found",
      });
    }
  }

  render() {
    const { id } = this.props.match.params;
    console.log("this.props.byVendor", this.props.byVendor);
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <AvForm
              className="needs-validation"
              onValidSubmit={this.handleValidSubmit}
            >
              <Row>
                <Col md={12} className="p-1 W-100">
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      {!this.props.byVendor && (
                        <Link
                          to="/SrPurchaseOrderDashboard"
                          className="action-icon text-primary mr-2"
                        >
                          {" "}
                          <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                        </Link>
                      )}
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        New Work Order
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <Row className="pl-2 pr-2">
                        <Col md={4}>
                          <FormGroup className="mb-0 mr-2" row>
                            <Col md={4}>
                              <Label
                                htmlFor="rfqId"
                                className="col-form-label font-size-16"
                              >
                                Select Service Indent:
                              </Label>
                            </Col>
                            <Col md={8}>
                              {this.state.id === 0 && !this.props.byVendor && (
                                <Select
                                  id="rfqId"
                                  name="rfqId"
                                  classNamePrefix="select2-selection"
                                  // options={this.props.serviceIndent?.map(
                                  //   (item, index) => ({
                                  //     label: item.code,
                                  //     value: item.id,
                                  //   })
                                  // )}
                                  options={
                                    Array.isArray(this.props.serviceIndent)
                                      ? this.props.serviceIndent.map(
                                          (item) => ({
                                            label: item.code,
                                            value: item.id,
                                          })
                                        )
                                      : []
                                  }
                                  value={{
                                    label:
                                      this.props.QRfQNo.rfqLabel == null
                                        ? "Select Service Indent No"
                                        : this.props.QRfQNo.rfqLabel,
                                    value:
                                      this.props.QRfQNo.requestforquotation_id,
                                  }}
                                  onChange={(e) => {
                                    this.props.rfqNoSelecteChangeValue({
                                      key: "rfqLabel",
                                      label: e.label,
                                      key2: "requestforquotation_id",
                                      value: e.value,
                                    });
                                  }}
                                />
                              )}
                              {(this.state.id !== 0 || this.props.byVendor) && (
                                <Input
                                  className="pr-0 "
                                  placeholder="RQF NO"
                                  type="text"
                                  disabled={true}
                                  name="rfqNo"
                                  id="rfqNo"
                                  value={
                                    this.props.byVendor
                                      ? this.props.RFQrowdata.code
                                      : this.props.QRowData
                                          .requestforquotation_code
                                  }
                                />
                              )}
                            </Col>
                          </FormGroup>
                        </Col>
                        {!this.props.byVendor && (
                          <Col md={2}>
                            <Button
                              type="button"
                              color="primary"
                              disabled={
                                this.state.id !== 0 || this.props.byVendor
                                  ? true
                                  : false
                              }
                              style={{
                                width: "100%",
                              }}
                              className="waves-effect waves-light "
                              onClick={() => this.loadRFQdata()}
                            >
                              Load Data
                            </Button>
                          </Col>
                        )}
                        <Col md={3}>
                          <FormGroup className="mb-0 p-1" row>
                            <Col md={4}>
                              <Label
                                htmlFor="vendorId"
                                className="col-form-label font-size-16"
                              >
                                Select Vendor:
                              </Label>
                            </Col>
                            <Col md={8}>
                              {!this.props.byVendor && (
                                // <Select
                                // 	id="vendorId"
                                // 	name="vendorId"
                                // 	classNamePrefix="select2-selection"
                                // 	isDisabled={
                                // 		this
                                // 			.props
                                // 			.qitems
                                // 			.length !==
                                // 		0
                                // 			? false
                                // 			: true
                                // 	}
                                // 	options={this.props.vendorslist?.map(
                                // 		(
                                // 			item,
                                // 			index
                                // 		) => ({
                                // 			label: item.name,
                                // 			value: item.id,
                                // 		})
                                // 	)}
                                // 	value={{
                                // 		label:
                                // 			this
                                // 				.props
                                // 				.QRowData
                                // 				.vendLabel ==
                                // 			null
                                // 				? "Select Vendor"
                                // 				: this
                                // 						.props
                                // 						.QRowData
                                // 						.vendLabel,
                                // 		value: this
                                // 			.props
                                // 			.QRowData
                                // 			.vendor_id,
                                // 	}}
                                // 	onChange={(
                                // 		e
                                // 	) => {
                                // 		this.props.SelecteChangeValue(
                                // 			{
                                // 				key: "vendLabel",
                                // 				label: e.label,
                                // 				key2: "vendor_id",
                                // 				value: e.value,
                                // 			}
                                // 		);
                                // 	}}
                                // />
                                <Select
                                  id="vendorId"
                                  name="vendorId"
                                  classNamePrefix="select2-selection"
                                  isDisabled={
                                    this.props?.qitems?.length !== 0
                                      ? false
                                      : true
                                  }
                                  loading={this.props.vendorsLoading}
                                  onInputChange={(inputValue, { action }) => {
                                    // Only trigger search on user input, not on select/deselect
                                    if (action === "input-change") {
                                      this.props.getMiniVendors({
                                        ...this.props.vendorParams,
                                        page: 1,
                                        page_size: 10,
                                        search: inputValue,
                                      });
                                    }
                                  }}
                                  options={this.props.vendorslist?.map(
                                    (item) => ({
                                      label: item.name,
                                      value: item.id,
                                    })
                                  )}
                                  onMenuOpen={() => {
                                    this.props.getMiniVendors({
                                      ...this.props.vendorParams,
                                      page: 1,
                                      page_size: 10,
                                      search: "",
                                    });
                                  }}
                                  // onMenuClose={() => {
                                  // 	this.props.clearMiniVendors();
                                  // }}
                                  onMenuScrollToBottom={() => {
                                    if (
                                      this.props.vendorParams.page <
                                      this.props.vendorParams.no_of_pages
                                    ) {
                                      this.props.getMiniVendors({
                                        ...this.props.vendorParams,
                                        page: this.props.vendorParams.page + 1,
                                        page_size: 10,
                                      });
                                    }
                                  }}
                                  value={{
                                    label:
                                      this.props.QRowData.vendLabel == null
                                        ? "Select Vendor"
                                        : this.props.QRowData.vendLabel,
                                    value: this.props.QRowData.vendor_id,
                                  }}
                                  onChange={(e) => {
                                    this.props.SelecteChangeValue({
                                      key: "vendLabel",
                                      label: e.label,
                                      key2: "vendor_id",
                                      value: e.value,
                                    });
                                  }}
                                />
                              )}
                              {this.props.byVendor && (
                                <Input
                                  className="pr-0 "
                                  placeholder="RQF NO"
                                  type="text"
                                  disabled={true}
                                  name="rfqNo"
                                  id="rfqNo"
                                  value={this.props.VendorData.vendor_name}
                                />
                              )}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className="mb-0 p-1" row>
                            <Col md={4}>
                              <Label
                                htmlFor="deliverydate"
                                className="col-form-label font-size-16"
                              >
                                Delivery Date:
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                className="pr-0 "
                                placeholder="Quantity"
                                type="date"
                                min={moment(new Date()).format("YYYY-MM-DD")}
                                disabled={
                                  this.props.qitems.length !== 0 ? false : true
                                }
                                name="deliverydate"
                                id="deliverydate"
                                value={
                                  this.props.QRowData.deliverydate == null
                                    ? "Select date"
                                    : this.props.QRowData.deliverydate
                                }
                                onChange={this.ChangeHandeler}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label
                                htmlFor="delivery"
                                className="col-form-label "
                              >
                                Delivery :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                name="delivery"
                                type="text"
                                value={this.props.QRowData.delivery ?? ""}
                                onChange={this.ChangeHandeler}
                                className="form-control"
                                id="delivery"
                                placeholder="Enter Delivery"
                                errormessage=" Please provide a valid text"
                                validate={{
                                  required: {
                                    value: true,
                                  },
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label
                                htmlFor="transport"
                                className="col-form-label "
                              >
                                Transport :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                name="transport"
                                type="text"
                                value={this.props.QRowData.transport ?? ""}
                                onChange={this.ChangeHandeler}
                                className="form-control"
                                id="transport"
                                placeholder="Enter Transport"
                                errormessage=" Please provide a valid text"
                                validate={{
                                  required: {
                                    value: true,
                                  },
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label
                                htmlFor="payment"
                                className="col-form-label "
                              >
                                Payment :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                name="payment"
                                type="text"
                                value={this.props.QRowData.payment ?? ""}
                                onChange={this.ChangeHandeler}
                                className="form-control"
                                id="payment"
                                placeholder="Enter Payment"
                                errormessage=" Please provide a valid text"
                                validate={{
                                  required: {
                                    value: true,
                                  },
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label
                                htmlFor="gstdetails"
                                className="col-form-label "
                              >
                                Gst Details :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                name="gstdetails"
                                type="text"
                                value={this.props.QRowData.gstdetails ?? ""}
                                onChange={this.ChangeHandeler}
                                className="form-control"
                                id="gstdetails"
                                placeholder="Enter Gst Details"
                                errormessage=" Please provide a valid text"
                                validate={{
                                  required: {
                                    value: true,
                                  },
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label
                                htmlFor="location"
                                className="col-form-label "
                              >
                                Location :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Select
                                id="Department-selection"
                                name="Department-selection"
                                classNamePrefix="select2-selection"
                                options={this.props.userLocation.map(
                                  (item, index) => ({
                                    label: item.name,
                                    value: item.id,
                                  })
                                )}
                                value={{
                                  label:
                                    this.props.location.location == null
                                      ? "Select Location"
                                      : this.props.location.location,
                                  value: this.props.location.location_id,
                                }}
                                onChange={(e) => {
                                  this.props.rfqLocationSelecteChangeValue({
                                    key: "location",
                                    label: e.label,
                                    key2: "location_id",
                                    value: e.value,
                                  });
                                  console.log(
                                    "Print Locatio Log",
                                    this.props.location.location
                                  );
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup row>
                            <Col md={4}>
                              <Label htmlFor="pnf" className="col-form-label ">
                                P&F :
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                name="pnf"
                                type="text"
                                value={this.props.QRowData.pnf ?? ""}
                                onChange={this.ChangeHandeler}
                                className="form-control"
                                id="pnf"
                                placeholder="Enter PNF"
                                errormessage=" Please provide a valid text"
                                validate={{
                                  required: {
                                    value: true,
                                  },
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="m-1">
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 ">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="">S.No</th>
                                        <th className="">Item Images</th>
                                        <th>Item Name</th>
                                        <th>Available Qty</th>
                                        <th>Item Base Price</th>
                                        <th>Item Discount(%)</th>
                                        <th>Item Price</th>
                                        <th>Tax Type</th>
                                        <th>Tax (%)</th>
                                        <th>Gross Value</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.qitems.length !== 0 ? (
                                        <>
                                          {this.props.qitems?.map(
                                            (item, key) => (
                                              <>
                                                {!item.dodelete && (
                                                  <tr key={key}>
                                                    <td className="text-center">
                                                      {key + 1}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                      <div className="product-detail text-center">
                                                        <img
                                                          src={
                                                            item?.product
                                                              ?.image == null
                                                              ? DefaultImg
                                                              : item?.product
                                                                  ?.image
                                                          }
                                                          alt="product-img"
                                                          title="product-img"
                                                          className="product-img  img-fluid mx-auto tab-img rounded"
                                                          style={{
                                                            height: "100px",
                                                            width: "150px",
                                                          }}
                                                        />
                                                      </div>
                                                    </td>
                                                    <td
                                                      style={{
                                                        minWidth: "220px",
                                                      }}
                                                    >
                                                      <h5 className="font-size-14">
                                                        <Link
                                                          to="#"
                                                          onClick={() =>
                                                            this.tog_static(
                                                              item
                                                            )
                                                          }
                                                          className="text-dark"
                                                        >
                                                          {item.product.name}
                                                        </Link>
                                                      </h5>
                                                      <p className="mb-0">
                                                        <b className="text-dark">
                                                          Make :
                                                        </b>{" "}
                                                        <span className="font-weight-medium">
                                                          {item.make}
                                                        </span>
                                                      </p>
                                                      <p className="mb-0">
                                                        <b className="text-dark">
                                                          Quantity :{" "}
                                                        </b>
                                                        <span className="font-weight-medium">
                                                          {item.originalqty}{" "}
                                                          {item.unit.name}
                                                        </span>
                                                      </p>
                                                      <p className="mb-0">
                                                        <Link
                                                          to="#"
                                                          //  onClick={() =>
                                                          //this.props.getMRItemImges(
                                                          //</p> item.id
                                                          // )
                                                          // }
                                                          className="text-primary"
                                                        >
                                                          <u className=" text-primary">
                                                            View Images
                                                          </u>
                                                        </Link>
                                                      </p>
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        minWidth: "220px",
                                                      }}
                                                    >
                                                      <AvGroup>
                                                        <InputGroup>
                                                          <AvField
                                                            placeholder="Quantity"
                                                            className=" pr-0 m-0 "
                                                            type="number"
                                                            validate={{
                                                              required: {
                                                                value: true,
                                                                errorMessage:
                                                                  "Please enter Qty",
                                                              },
                                                              max: {
                                                                value:
                                                                  item?.originalqty,
                                                                errorMessage:
                                                                  "Please enter max " +
                                                                  item?.originalqty,
                                                              },
                                                              min: {
                                                                value: 0.001,
                                                                errorMessage:
                                                                  "Please enter min 0.1",
                                                              },
                                                              pattern: {
                                                                value:
                                                                  "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                                errorMessage:
                                                                  "Qty can compose numbers and 3 decimals ",
                                                              },
                                                            }}
                                                            name={"qty" + key}
                                                            id={"qty" + key}
                                                            value={item?.qty}
                                                            onChange={(e) =>
                                                              this.caluclategross(
                                                                e,
                                                                item,
                                                                1
                                                              )
                                                            }
                                                          />
                                                          <InputGroupAddon>
                                                            {item.unit.name}
                                                          </InputGroupAddon>
                                                        </InputGroup>
                                                      </AvGroup>
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        minWidth: "150px",
                                                      }}
                                                    >
                                                      <InputGroup>
                                                        <Input
                                                          placeholder="Item Base Price"
                                                          min={0}
                                                          type="number"
                                                          name={
                                                            "baseprice" + key
                                                          }
                                                          id="baseprice"
                                                          value={item.baseprice}
                                                          onChange={(e) =>
                                                            this.caluclategross(
                                                              e,
                                                              item,
                                                              5
                                                            )
                                                          }
                                                          validate={{
                                                            required: {
                                                              value: true,
                                                              errorMessage:
                                                                "Please enter Gross Value",
                                                            },
                                                            min: {
                                                              value: 0.1,
                                                              errorMessage:
                                                                "Please enter min Amount",
                                                            },
                                                          }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                          <InputGroupText>
                                                            &#8377;
                                                          </InputGroupText>
                                                        </InputGroupAddon>
                                                      </InputGroup>
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                    >
                                                      <AvGroup>
                                                        <InputGroup>
                                                          <AvInput
                                                            placeholder="Item discount(%)"
                                                            className=" pr-0 m-0 "
                                                            type="number"
                                                            validate={{
                                                              required: {
                                                                value: true,
                                                                errorMessage:
                                                                  "Please enter Discount Percent",
                                                              },
                                                              min: {
                                                                value: 0,
                                                                errorMessage:
                                                                  "Please enter min %",
                                                              },
                                                              max: {
                                                                value: 100,
                                                                errorMessage:
                                                                  "Please enter max % ",
                                                              },
                                                            }}
                                                            name={
                                                              "discountpercent" +
                                                              key
                                                            }
                                                            id={
                                                              "discountpercent" +
                                                              key
                                                            }
                                                            value={
                                                              item.discountpercent
                                                            }
                                                            onChange={(e) =>
                                                              this.caluclategross(
                                                                e,
                                                                item,
                                                                2
                                                              )
                                                            }
                                                          />
                                                          <InputGroupAddon>
                                                            %
                                                          </InputGroupAddon>
                                                        </InputGroup>
                                                      </AvGroup>
                                                      {/* <InputGroup>
                                                        <Input
                                                          placeholder="Item discountpercent"
                                                          min={0}
                                                          type="number"
                                                          name={
                                                            "discountpercent" +
                                                            key
                                                          }
                                                          id={
                                                            "discountpercent" +
                                                            key
                                                          }
                                                          value={
                                                            item.discountpercent
                                                          }
                                                          onChange={(e) =>
                                                            this.caluclategross(
                                                              e,
                                                              item,
                                                              2
                                                            )
                                                          }
                                                          validate={{
                                                            required: {
                                                              value: true,
                                                              errorMessage:
                                                                "Please enter Discount Percent",
                                                            },
                                                            min: {
                                                              value: 0.1,
                                                              errorMessage:
                                                                "Please enter min Discount Percent",
                                                            },
                                                          }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                          <InputGroupText>
                                                            %
                                                          </InputGroupText>
                                                        </InputGroupAddon>
                                                      </InputGroup> */}
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        minWidth: "150px",
                                                      }}
                                                    >
                                                      <InputGroup>
                                                        <Input
                                                          placeholder="Item Price"
                                                          min={0}
                                                          type="number"
                                                          name={"price" + key}
                                                          id="price"
                                                          value={item.price}
                                                          disabled={true}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                          <InputGroupText>
                                                            &#8377;
                                                          </InputGroupText>
                                                        </InputGroupAddon>
                                                      </InputGroup>

                                                      <p>
                                                        Item Discount: &#8377;{" "}
                                                        {item.discount}
                                                      </p>
                                                    </td>
                                                    <td
                                                      className=" text-center"
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      <Select
                                                        id="taxtype_select"
                                                        name={
                                                          "taxtype_select" + key
                                                        }
                                                        required="required"
                                                        options={taxTypeOptions}
                                                        value={{
                                                          label:
                                                            item.taxtype
                                                              ?.name == null
                                                              ? item.taxtype ===
                                                                1
                                                                ? "Inclusive"
                                                                : item.taxtype ===
                                                                  2
                                                                ? "Exclusive"
                                                                : ""
                                                              : item.taxtype
                                                                  ?.name,
                                                          value:
                                                            item.taxtype?.id,
                                                        }}
                                                        onChange={(e) => {
                                                          this.caluclategross(
                                                            e,
                                                            item,
                                                            3
                                                          );
                                                        }}
                                                      />
                                                    </td>
                                                    <td
                                                      className=" text-center"
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      <Select
                                                        id="units_select"
                                                        name={
                                                          "units_select" + key
                                                        }
                                                        required="required"
                                                        options={this.props.Taxlist.map(
                                                          (i) => ({
                                                            label: i.name,
                                                            value: i.id,
                                                          })
                                                        )}
                                                        value={{
                                                          label: item.tax?.name,
                                                          value: item.tax?.id,
                                                        }}
                                                        onChange={(e) => {
                                                          this.caluclategross(
                                                            e,
                                                            item,
                                                            4
                                                          );
                                                        }}
                                                      />
                                                      <p>
                                                        Tax Amount: &#8377;{" "}
                                                        {item.taxamt}
                                                      </p>
                                                    </td>
                                                    <td
                                                      className="text-center"
                                                      style={{
                                                        minWidth: "180px",
                                                      }}
                                                    >
                                                      <AvField
                                                        placeholder="Gross Value"
                                                        className=" pr-0 pt-1 form-control"
                                                        type="number"
                                                        readOnly
                                                        validate={{
                                                          required: {
                                                            value: true,
                                                            errorMessage:
                                                              "Please enter Gross Value",
                                                          },
                                                          min: {
                                                            value: 0.1,
                                                            errorMessage:
                                                              "Please enter min 0.1 or remove the item from the list",
                                                          },
                                                          pattern: {
                                                            value:
                                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                            errorMessage:
                                                              "Qty can compose numbers and 3 decimals ",
                                                          },
                                                        }}
                                                        name={"gross" + key}
                                                        id={"gross" + key}
                                                        value={item.gross}
                                                      />
                                                      {/* <InputGroup>
                                                        <Input
                                                          type="number"
                                                          className="form-control"
                                                          placeholder="Gross Value"
                                                          
                                                          value={item.gross}
                                                          name={"gross"+key}
                                                          required
                                                          />
                                                        <InputGroupAddon addonType="append">
                                                          <InputGroupText>
                                                            &#8377;
                                                          </InputGroupText>
                                                        </InputGroupAddon>
                                                      </InputGroup> */}
                                                    </td>
                                                    <td>
                                                      <Button
                                                        type="button"
                                                        color="danger"
                                                        className="waves-effect waves-light"
                                                        onClick={() => {
                                                          this.RemoveQItem(
                                                            item
                                                          );
                                                        }}
                                                      >
                                                        <i className="mdi mdi-close"></i>
                                                      </Button>
                                                    </td>
                                                  </tr>
                                                )}
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={9}
                                            className="text-center"
                                          >
                                            <div>
                                              <span className="font-size-18 text-danger">
                                                Data not available
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1 ">
                              <i className="mdi mdi-alert-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Terms & Conditions
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="terms"
                                    id="txtterms"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Terms & Conditions"
                                    rows="7"
                                    value={
                                      this.props.QRowData.terms == null
                                        ? ""
                                        : this.props.QRowData.terms
                                    }
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Other Details
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="description"
                                    id="description"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Details"
                                    value={
                                      this.props.QRowData.description == null
                                        ? ""
                                        : this.props.QRowData.description
                                    }
                                    rows="7"
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1 ">
                              <i className="mdi mdi-alert-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Internal Remarks
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="remarks"
                                    id="remarks"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Internal Remarks"
                                    rows="7"
                                    value={
                                      this.props.QRowData.remarks == null
                                        ? ""
                                        : this.props.QRowData.remarks
                                    }
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Externale Remarks
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="externalremarks"
                                    id="externalremarks"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter External Remarks"
                                    value={
                                      this.props.QRowData.externalremarks ==
                                      null
                                        ? ""
                                        : this.props.QRowData.externalremarks
                                    }
                                    rows="7"
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      <CardFooter className="bg-transparent p-1">
                        <div className="float-right">
                          {this.props.byVendor && (
                            <Link to={"/vendorlogin/" + this.props.token}>
                              <Button
                                type="reset"
                                color="light"
                                className="waves-effect waves-light mr-2"
                              >
                                Cancel
                              </Button>
                            </Link>
                          )}
                          {!this.props.byVendor && (
                            <Link to="/SrPurchaseOrderDashboard">
                              <Button
                                type="button"
                                color="light"
                                className="waves-effect waves-light mr-2"
                              >
                                Cancel
                              </Button>
                            </Link>
                          )}
                          {!this.props.loading ? (
                            <Button
                              type="submit"
                              color="primary"
                              className="waves-effect waves-light"
                            >
                              Submit
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              className="waves-effect waves-light"
                            >
                              Loading... Please Wait
                            </Button>
                          )}
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              // ItemLevel="QLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            {this.props.RFQMRItemImagesModel && (
              <MRItemImages
                modelOpen={this.props.RFQMRItemImagesModel}
                MRIImageData={this.props.RFQMRItemImages}
                modelClose={() => {
                  this.props.RFQMRItemImagesModel_close();
                }}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    userLocation,
    Taxlist,
    vendor,
    vendorslist,
    vendorsLoading,
    vendorParams,
  } = state.Mini;
  const { VendorData } = state.VendorQuotation;
  const {
    // serviceIndent,
    serviceIndent,
    QRfQNo,
    location,
    QRowData,
    qitems,
    RFQrowdata,
    loading,
    RFQMRItemImages,
    RFQMRItemImagesModel,
  } = state.SRPurchaseOrder;

  return {
    userLocation,
    Taxlist,
    VendorData,
    serviceIndent,
    QRfQNo,
    location,
    QRowData,
    vendorslist,
    vendorsLoading,
    vendorParams,
    qitems,
    RFQrowdata,
    loading,
    RFQMRItemImages,
    RFQMRItemImagesModel,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getMiniVendors,
  getMiniTaxs,
  getServiceIndentList,
  InputChangeValue,
  rfqNoSelecteChangeValue,
  rfqLocationSelecteChangeValue,
  SelecteChangeValue,
  getServiceRequestRequestdata,
  itemQtyChangeValue,
  itemUnitSelecteChangeValue,
  itemPriceChangeValue,
  itemDiscountPercentChangeValue,
  itemBasePriceChangeValue,
  itemTaxSelecteChangeValue,
  itemTaxTypeSelecteChangeValue,
  itemGrossValChangeValue,
  getQuotationData,
  quotationAdd,
  QItemRemove,
  // getMRItemImges,

  RFQMRItemImagesModel_close,
})(NewQuotation);
